import React, { useState, useEffect } from 'react';

import Toggle from 'cccisd-toggle';
import _get from 'lodash/get';

import style from './style.css';

import { switchPlanNameIfNeeded } from '../helpers';

const PlanCard = ({ plan, selectedPlans, setSelectedPlans }) => {
    const { planName, assignments, youthDeploymentHandles, caregiverDeploymentHandles, isOrgPlan } = plan;
    const [opened, setOpened] = useState(false);
    const [planSelected, setPlanSelected] = useState(true);
    const [sectionsOpened, setSectionsOpened] = useState({});

    useEffect(() => {
        // update list of selected Plans
        const uniqueYouthPlans = [];
        const uniqueCaregiverPlans = [];

        youthDeploymentHandles.forEach(handle => {
            const res = handle.split('_').slice(0, 2).join('_');
            if (!uniqueYouthPlans.includes(res)) {
                uniqueYouthPlans.push(res);
            }
        });
        caregiverDeploymentHandles.forEach(handle => {
            const res = handle.split('_').slice(0, 2).join('_');
            if (!uniqueCaregiverPlans.includes(res)) {
                uniqueCaregiverPlans.push(res);
            }
        });

        // adding to selected plans list
        if (planSelected) {
            if (isOrgPlan) {
                setSelectedPlans(prev => {
                    prev.orgYouthPlan = [..._get(selectedPlans, 'orgYouthPlan', []), ...uniqueYouthPlans];
                    prev.orgCaregiverPlan = [..._get(selectedPlans, 'orgCaregiverPlan', []), ...uniqueCaregiverPlans];

                    return prev;
                });
            } else {
                setSelectedPlans(prev => {
                    prev.primaryYouthPlan = [..._get(selectedPlans, 'primaryYouthPlan', []), ...uniqueYouthPlans];
                    prev.primaryCaregiverPlan = [
                        ..._get(selectedPlans, 'primaryCaregiverPlan', []),
                        ...uniqueCaregiverPlans,
                    ];

                    return prev;
                });
            }
        } else {
            // removing plans from selected plans list
            isOrgPlan
                ? setSelectedPlans(prev => {
                      prev.orgYouthPlan = [
                          ..._get(selectedPlans, 'orgYouthPlan', []).filter(
                              handle => !uniqueYouthPlans.includes(handle)
                          ),
                      ];
                      prev.orgCaregiverPlan = [
                          ..._get(selectedPlans, 'orgCaregiverPlan', []).filter(
                              handle => !uniqueCaregiverPlans.includes(handle)
                          ),
                      ];

                      return prev;
                  })
                : setSelectedPlans(prev => {
                      prev.primaryYouthPlan = [
                          ..._get(selectedPlans, 'primaryYouthPlan', []).filter(
                              handle => !uniqueYouthPlans.includes(handle)
                          ),
                      ];
                      prev.primaryCaregiverPlan = [
                          ..._get(selectedPlans, 'primaryCaregiverPlan', []).filter(
                              handle => !uniqueCaregiverPlans.includes(handle)
                          ),
                      ];

                      return prev;
                  });
        }
    }, [planSelected]);

    return (
        <div
            onClick={() => {
                setOpened(prev => !prev);
            }}
            className={style.plan_card_preview_container}
        >
            <span
                style={{
                    display: 'inline-block',
                    transition: 'transform 0.2s',
                    transform: opened ? 'rotate(90deg)' : 'rotate(0deg)',
                    marginRight: '10px',
                }}
            >
                ▶
            </span>
            <span style={{ fontSize: '24px' }}>{`${switchPlanNameIfNeeded(planName)}`}</span>
            <div className={style.plan_card_selection_toggle_container} id={planName + '_planToggle'}>
                <Toggle
                    id="testid"
                    onChange={val => {
                        setPlanSelected(prev => !prev);
                    }}
                    value={planSelected}
                />
            </div>
            {opened && (
                <div style={{ marginTop: '30px' }}>
                    <div style={{ margin: '10px' }}>
                        <div className={style.plan_card_body_container} onClick={e => e.stopPropagation()}>
                            {assignments.map((assignment, i) => {
                                const surveys = _get(assignment, 'surveys', []);
                                const openedKey = assignment.assignmentLabel + i;

                                return (
                                    <div
                                        key={i}
                                        style={{
                                            cursor: 'pointer',
                                            background: '#b7a77a30',
                                            padding: '20px',
                                            marginBottom: '15px',
                                            borderRadius: '5px',
                                        }}
                                        onClick={e => {
                                            setSectionsOpened(prev => ({
                                                ...prev,
                                                [`${openedKey}`]: prev[openedKey] ? false : true,
                                            }));
                                        }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    transition: 'transform 0.2s',
                                                    transform: sectionsOpened[openedKey]
                                                        ? 'rotate(90deg)'
                                                        : 'rotate(0deg)',
                                                    marginRight: '10px',
                                                }}
                                            >
                                                ▶
                                            </span>
                                            <div>
                                                <h5>{assignment.assignmentLabel}</h5>
                                            </div>
                                        </div>

                                        {sectionsOpened[openedKey] && (
                                            <>
                                                <div className={style.dividing_line} />
                                                {surveys.map((survey, j) => {
                                                    const { surveyLabel, surveyQuestions } = survey;
                                                    const weekOpenedKey = `${openedKey}` + surveyLabel + j;

                                                    return (
                                                        <div
                                                            key={j}
                                                            className={style.plan_card_survey_preview_container}
                                                            onClick={e => {
                                                                setSectionsOpened(prev => ({
                                                                    ...prev,
                                                                    [`${weekOpenedKey}`]: prev[weekOpenedKey]
                                                                        ? false
                                                                        : true,
                                                                }));
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        transition: 'transform 0.2s',
                                                                        transform: sectionsOpened[weekOpenedKey]
                                                                            ? 'rotate(90deg)'
                                                                            : 'rotate(0deg)',
                                                                        marginRight: '10px',
                                                                    }}
                                                                >
                                                                    ▶
                                                                </span>
                                                                <div>
                                                                    <h6
                                                                        style={{
                                                                            fontWeight: 'bold',
                                                                        }}
                                                                    >
                                                                        {surveyLabel}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                            {sectionsOpened[weekOpenedKey] && (
                                                                <>
                                                                    <ol>
                                                                        {surveyQuestions.map((question, k) => {
                                                                            return (
                                                                                <li key={k}>
                                                                                    <div
                                                                                        style={{
                                                                                            margin: '10px',
                                                                                            fontSize: '13px',
                                                                                            fontWeight: '300',
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: question,
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })}
                                                                    </ol>
                                                                </>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PlanCard;
